//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PostUserHeader from "./PostUserHeader.vue";
import PostMetaInfo from "./PostMetaInfo.vue";
import PostWork from "./PostWork.vue";
import TextWap from "./TextWap.vue";
import MiniPlayer from '@/components/music_player/MiniPlayer.vue'

export default {
  name: "workAudio",
  created() {},
  props: ["post"],
  data() {
    return {};
  },
  mounted() {
    // let wapWidth = this.$refs.iframeWap.offsetWidth;
    // let iframe = document.getElementsByTagName("iframe")[0];

    // if (!iframe) {
    //   return;
    // }

    // let iframeOriginalWidth = parseInt(iframe.getAttribute("width"));
    // let iframeOriginalHeight = parseInt(iframe.getAttribute("height"));
    // let iframeWidth, iframeHeight;

    // iframeWidth = wapWidth;

    // if (iframeOriginalWidth && iframeOriginalHeight) {
    //   iframeHeight = iframeWidth / iframeOriginalWidth * iframeOriginalHeight;
    // } else {
    //   iframeHeight = iframeWidth * 0.8;
    // }

    // iframe.setAttribute("width", iframeWidth);
    // iframe.setAttribute("height", iframeHeight);
  },
  methods: {
    onClickPlayer (item) {
      this.$store.commit('setAudioMsg', item)
      // console.log('item', item)
    },

    onAudioError: function(e) {
      // let s = "";
      // let err = this.$refs.audio.error;
      // switch (err.code) {
      //   case MediaError.MEDIA_ERR_ABORTED:
      //     s += "The user canceled the audio.";
      //     break;
      //   case MediaError.MEDIA_ERR_NETWORK:
      //     s += "A network error occurred while fetching the audio.";
      //     break;
      //   case MediaError.MEDIA_ERR_DECODE:
      //     s += "An error occurred while decoding the audio.";
      //     break;
      //   case MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED:
      //     s +=
      //       "The audio is missing or is in a format not supported by your browser.";
      //     break;
      //   default:
      //     s += "An unknown error occurred.";
      //     break;
      // }
      // let message = err.message;
      // if (message && message.length) {
      //   s += " " + message;
      // }
      // alert(s);
    }
  },
  computed: {
    audioUrl: function() {
      return this.post.compressedAudio
        ? this.post.compressedAudio.url
        : this.post.audio.url;
    }
    // audioUrl () {
    //   return this.post.get('audio').get('url')
    // }
  },
  components: {
    PostUserHeader,
    PostMetaInfo,
    PostWork,
    TextWap,
    MiniPlayer
  }
};



// WEBPACK FOOTER //
// ./src/components/post/PostAudio.vue